import { useState, useEffect, useCallback, useContext } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardActions,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Autocomplete, Divider, TextField } from "@mui/material";
import { AppContext } from "./../../contexts/appContext";
import { userAPI } from "../../services/UserService";
import { gcAPI } from "../../services/GroupCategoryService";
import Swal from "sweetalert2";

const CardProduct = ({
  res,
  userEditData,
  setUserEditData,
  setData,
  setUserData,
  page,
}) => {
  const { user } = useContext(AppContext);
  const [edit, setEdit] = useState(false);
  const [selectRetail, setSelectRetail] = useState(null);
  const [selectBuyer, setSelectBuyer] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChangeProduct = useCallback(
    async ({ Group, Category, Brand }) => {
      try {
        setLoading(true);
        const { status, message } = await gcAPI.editCategory({
          Group,
          Category,
          Brand,
          retail: selectRetail.username,
          buyer: selectBuyer.username,
        });
        if (status != 200) throw { message };
        setUserData((old) => {
          try {
            if (!old instanceof Array) throw "not array";
            let newArray = [...old];
            let find1 = newArray.find(
              (res) => res.username == selectRetail.username
            );
            let find2 = newArray.find(
              (res) => res.username == selectBuyer.username
            );
            if (!find1) {
              newArray.push(selectRetail);
            }
            if (!find2) {
              newArray.push(selectBuyer);
            }
            return newArray;
          } catch (error) {
            return [];
          }
        });
        setData((old) => {
          try {
            if (!old instanceof Array) throw "not array";
            let newArray = [...old];
            let indexArray = newArray.findIndex(
              (res) => res.Group == Group && res.Category == Category
            );
            if (indexArray != -1) {
              if (newArray[indexArray].brand instanceof Array) {
                let brandArray = newArray[indexArray].brand.findIndex(
                  (res) => res.name == Brand
                );
                if (brandArray != -1) {
                  newArray[indexArray].brand[brandArray].buyer =
                    selectBuyer.username;
                  newArray[indexArray].brand[brandArray].retail =
                    selectRetail.username;
                }
              }
            }
            return newArray;
          } catch (error) {
            return [];
          }
        });
        setLoading(false);
        setEdit(false);
      } catch (error) {
        setLoading(false);
        alert(error.message);
      }
    },
    [res, selectRetail, selectBuyer]
  );

  useEffect(() => {
    if (res?.retail) {
      setSelectRetail(res?.retail);
    }
    if (res?.buyer) {
      setSelectBuyer(res?.buyer);
    }

    if (edit && userEditData.length == 0) {
      userAPI
        .getUserSetting()
        .then((res) => {
          if (res.status == 200 && res.message instanceof Array) {
            setUserEditData(res.message);
          }
        })
        .catch((errror) => {
          console.log(errror);
        });
    }
    return () => {
      if (!edit) {
        setSelectRetail(null);
        setSelectBuyer(null);
      }
    };
  }, [edit]);

  useEffect(() => {
    setEdit(false);
    setSelectRetail(null);
    setSelectBuyer(null);
  }, [page]);

  const handleDelete = useCallback(async () => {
    try {
      const { isConfirmed } = await Swal.fire({
        title: 'คุณแน่ใจ ?',
        text: `ต้องการลบ ${res.Group} - ${res.Category}${res.Brand ? ` - ${res.Brand}` : ''}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#56A834',
        cancelButtonColor: '#f43f5e',
        confirmButtonText: 'แน่ใจ',
        cancelButtonText: 'ยังก่อน'
      })
      if (isConfirmed) {
        setLoading(true)
        const { message, status } = await gcAPI.deleteCategory({ Group: res.Group, Category: res.Category, Brand: res.Brand })
        if (!status == 200) throw { message }
        Swal.fire({
          title: "แจ้งเตือน",
          text: `ลบ ${res.Group} - ${res.Category}${res.Brand ? ` - ${res.Brand}` : ''} เรียบร้อยแล้ว`,
          icon: "success",
          confirmButtonColor: "#56A834",
        });
        setData((old) => old.filter((rez) => res.Group != rez.Group && res.Category != rez.Category && res.Brand != rez.Brand))
        setLoading(false)
      }
    } catch (error) {
      Swal.fire({
        title: "แจ้งเตือน",
        text: error.message,
        icon: "error",
        confirmButtonColor: "#f43f5e",
      });
      setLoading(false)
    }

  }, [res])

  return (
    <Box
      className="box-product"
      style={{
        height: !edit ? (user?.manage_product ? "440px" : "420px") : "500px",
      }}
    >
      <Card className="card-product">
        <CardContent>
          <Box className="card-header-product">
            <Box className="card-title-product" sx={{ margin: "auto" }}>
              Group.Cat:
            </Box>
            <Box sx={{ fontSize: 18, fontWeight: 700 }}>{res.Group}</Box>
          </Box>
          <Box className="card-header-product" sx={{ marginTop: 0.5 }}>
            <Box className="card-title-product">Category:</Box>
            <Box className="card-value-product">{res.Category}</Box>
          </Box>
          <Box className="card-header-product">
            <Box className="card-title-product">Retail/ Brand:</Box>
            <Box className="card-value-product">{res.Brand || "-"}</Box>
          </Box>
        </CardContent>
        <CardContent style={{ padding: 12 }}>
          {!edit ? (
            <TableContainer component={Paper} className="table-product">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="header-gray">ID</TableCell>
                    <TableCell className="header-gray">Buyer</TableCell>
                    <TableCell className="header-gray">เบอร์โต๊ะ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="header-black">
                      {res?.buyer?.username || "-"}
                    </TableCell>
                    <TableCell className="header-black">
                      {res?.buyer?.fullname || "-"}
                    </TableCell>
                    <TableCell className="header-blue">
                      {res?.buyer?.table || "-"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box style={{ padding: 4 }}>
              <Autocomplete
                options={userEditData || []}
                onChange={(e, v) => setSelectBuyer(v)}
                getOptionLabel={(op) => (op.fullname ? op.fullname : "")}
                value={selectBuyer || ""}
                isOptionEqualToValue={(option) =>
                  option.username == selectBuyer?.username
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="เลือก Buyer"
                    variant="standard"
                  />
                )}
              />
              <Box style={{ margin: "20px 0", display: "flex" }}>
                ID: {selectBuyer?.username || "-"}{" "}
                <Divider
                  style={{ margin: "0 20px" }}
                  orientation="vertical"
                  flexItem
                />{" "}
                เบอร์โต๊ะ: {selectBuyer?.table || "-"}
              </Box>
            </Box>
          )}
        </CardContent>
        <CardContent style={{ padding: 12 }}>
          {!edit ? (
            <TableContainer component={Paper} className="table-product">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="header-gray">ID</TableCell>
                    <TableCell className="header-gray">Retail</TableCell>
                    <TableCell className="header-gray">เบอร์โต๊ะ</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="header-black">
                      {res?.retail?.username || "-"}
                    </TableCell>
                    <TableCell className="header-black">
                      {res?.retail?.fullname || "-"}
                    </TableCell>
                    <TableCell className="header-blue">
                      {res?.retail?.table || "-"}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box style={{ padding: 4 }}>
              <Autocomplete
                options={userEditData || []}
                onChange={(e, v) => setSelectRetail(v)}
                getOptionLabel={(op) => (op.fullname ? op.fullname : "")}
                value={selectRetail || ""}
                isOptionEqualToValue={(option) =>
                  option.username == selectRetail?.username
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="เลือก Retail"
                    variant="standard"
                  />
                )}
              />
              <Box style={{ margin: "20px 0", display: "flex" }}>
                ID: {selectRetail?.username || "-"}{" "}
                <Divider
                  style={{ margin: "0 20px" }}
                  orientation="vertical"
                  flexItem
                />{" "}
                เบอร์โต๊ะ: {selectRetail?.table || "-"}
              </Box>
            </Box>
          )}
        </CardContent>
        {user?.manage_product && (
          <CardActions>
            <Button
              style={{
                textTransform: "none",
                textDecoration: "underline",
                fontWeight: 700,
              }}
              disabled={loading}
              onClick={() => setEdit((old) => !old)}
            >
              {edit ? "Cancel" : "Edit"}
            </Button>
            {edit && (
              <Button
                style={{
                  textTransform: "none",
                  fontWeight: 700,
                  marginLeft: "auto",
                  borderRadius: "10px",
                  padding: "6px 12px",
                  backgroundColor:
                    !selectBuyer || !selectRetail ? "lightgray" : "#6ab23a",
                  color: "#fff",
                }}
                disabled={!selectBuyer || !selectRetail || loading}
                onClick={() => handleChangeProduct({ ...res })}
              >
                {loading ? "Loading..." : "Submit"}
              </Button>
            )}
            {!edit && (
              <Button
                style={{
                  textTransform: "none",
                  textDecoration: "underline",
                  fontWeight: 700,
                  marginLeft: "auto",
                }}
                disabled={loading}
                onClick={handleDelete}
              >
                {loading ? "Loading..." : "Delete"}
              </Button>

            )}
          </CardActions>
        )}
      </Card>
    </Box>
  );
};

export default CardProduct;
